import React from "react";
import "./subscribeNews.scss";

const SubscribeNews = () => {
  return (
    <section id="subscribe-wrapper">
      <h3>Subscribe to get the latest news about us</h3>
      <div className="search-bar">
        <input type="email" placeholder="Email" />
        <button>Subscribe</button>
      </div>
    </section>
  );
};

export default SubscribeNews;
